<template>
  <div v-if="isBeingImpersonated">
    <div class="impersonated-frame" />
    <div class="impersonated-pill">
      <span class="pill-info">
        <span class="pill-dot" />
        O suporte da <b>API4COM</b> está acessando sua conta
        <span
          v-if="expiresLabel !== ''"
          class="pill-timer"
          title="Acesso liberado até">· até {{ expiresLabel }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import loopback from '@/services/loopback'

export default {
  name: 'ImpersonatedNotice',
  data: () => ({
    active: false,
    claimed: false,
    expiratedAt: null
  }),
  computed: {
    isOwnImpersonationSession () {
      return this.$store.state.auth.impersonation !== null
    },
    isBeingImpersonated () {
      return this.active === true && this.claimed === true
    },
    expiresLabel () {
      if (this.expiratedAt === null) return ''
      return new Date(this.expiratedAt).toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    }
  },
  mounted () {
    this.loadActive()
  },
  watch: {
    '$route': function () {
      this.loadActive()
    }
  },
  methods: {
    loadActive () {
      if (this.isOwnImpersonationSession === true) {
        this.active = false
        this.claimed = false
        this.expiratedAt = null
        return
      }
      loopback
        .get('/account-impersonations/active')
        .then(result => {
          this.active = result.active === true
          this.claimed = result.claimed === true
          this.expiratedAt = result.active === true ? result.expiratedAt : null
        })
        .catch(() => {
          this.active = false
          this.claimed = false
          this.expiratedAt = null
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.impersonated-frame {
  position: fixed;
  inset: 0;
  border: 3px solid #0ea5e9;
  pointer-events: none;
  z-index: 1030;
}

.impersonated-pill {
  position: fixed;
  left: 50%;
  top: 4px;
  transform: translateX(-50%);
  background: #0c2533;
  color: #fff;
  border-radius: 999px;
  padding: 10px 18px;
  display: flex;
  align-items: center;
  gap: 14px;
  box-shadow: 0 16px 40px rgba(14, 165, 233, 0.4);
  z-index: 1031;
}

.pill-info {
  display: flex;
  align-items: center;
  gap: 9px;
  font-size: 13.5px;
}
.pill-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #38bdf8;
  box-shadow: 0 0 0 4px rgba(56, 189, 248, 0.3);
}
.pill-timer {
  color: #9fd8f2;
  font-variant-numeric: tabular-nums;
}
</style>



// WEBPACK FOOTER //
// src/components/Support/ImpersonatedNotice.vue